import { columnTypes } from '../../constants/globals';
import { userActions } from '../../constants/user-actions';

export const tableConfig = (props) => {
  const {
    t,
    editAction,
    deleteAction,
    editPasswordAction,
    setUserStatusActive,
    setUserStatusDeactive,
    // setUserStatusDeactivate2fa,
    // edit2faRegistrationWhenStatusPassive,
    disableDelete,
    disableActivateDeactivate,
    allowedActions,
    unlockAction,
  } = props || {};

  const showEditColumn = allowedActions.includes(userActions.USER_UPDATE);
  const showDeleteColumn = allowedActions.includes(userActions.USER_DELETE);
  const showPassChangeColumn = allowedActions.includes(
    userActions.USER_PASSWORD_CHANGE
  );
  const showActivateDeactivateColumn =
    allowedActions.includes(userActions.USER_ACTIVATE) ||
    allowedActions.includes(userActions.USER_DEACTIVATE);
  // const showActivateDeactivate2FAColumn =
  //   allowedActions.includes(userActions.USER_REGISTER2FA, allowedActions) ||
  //   allowedActions.includes(userActions.USER_DEACTIVATE2FA, allowedActions);
  const showUnlockColumn = allowedActions?.includes(userActions.USER_UNLOCK);

  return {
    columns: [
      {
        key: 'username',
        width: '',
        className: '',
        type: columnTypes.value,
      },
      {
        key: 'firstName',
        width: '',
        className: 'text-center',
        type: columnTypes.value,
      },
      {
        key: 'lastName',
        width: '',
        className: 'text-center',
        type: columnTypes.value,
      },
      {
        key: 'ipBrojImena',
        width: '',
        className: 'text-center',
        type: columnTypes.value,
      },
      {
        key: 'ipBaseNumber',
        width: '',
        className: 'text-center',
        type: columnTypes.value,
      },
      {
        key: 'unlock',
        width: '7.5%',
        className: 'text-center',
        type: columnTypes.action,
        onClick: unlockAction,
        icon: 'fas fa-lock-open fa-2x',
        disable: (item) => !!item?.accountNonLocked,
        condition: () => showUnlockColumn,
      },
      {
        key: 'activateDeactivate',
        width: '',
        className: 'text-center',
        type: columnTypes.condition_action,
        actions: [
          {
            onClick_ca: setUserStatusDeactive,
            icon_ca: 'fas fa-times-circle fa-2x',
            tooltipTitle_ca: t.deactivate,
            condition_ca: true,
          },
          {
            onClick_ca: setUserStatusActive,
            icon_ca: 'fas fa-play-circle fa-2x',
            tooltipTitle_ca: t.activate,
            condition_ca: false,
          },
        ],
        conditionColumn: 'enabled',
        disable: disableActivateDeactivate,
        condition: () => showActivateDeactivateColumn,
      },
      {
        key: 'edit',
        width: '6.5%',
        className: 'text-center',
        type: columnTypes.action,
        onClick: editAction,
        icon: 'fas fa-edit fa-2x',
        condition: () => showEditColumn,
      },
      {
        key: 'resetPassword',
        width: '',
        className: 'text-center',
        type: columnTypes.action,
        onClick: editPasswordAction,
        icon: 'fas fa-key fa-2x',
        condition: () => showPassChangeColumn,
      },
      // {
      //   key: 'changeStatus2fa',
      //   width: '',
      //   className: 'text-center',
      //   type: columnTypes.condition_action,
      //   actions: [
      //     {
      //       onClick_ca: setUserStatusDeactivate2fa,
      //       icon_ca: 'fas fa-times-circle fa-2x',
      //       tooltipTitle_ca: t.deactivate2fa,
      //       condition_ca: true,
      //     },
      //     {
      //       onClick_ca: edit2faRegistrationWhenStatusPassive,
      //       icon_ca: 'fas fa-play-circle fa-2x',
      //       tooltipTitle_ca: t.activate2fa,
      //       condition_ca: false,
      //     },
      //   ],
      //   conditionColumn: 'useGoogle2f',
      //   condition: () => showActivateDeactivate2FAColumn,
      // },
      {
        key: 'delete',
        width: '6.8%',
        className: 'text-center',
        type: columnTypes.action,
        onClick: deleteAction,
        icon: 'fas fa-trash-alt fa-2x',
        disable: disableDelete,
        condition: () => showDeleteColumn,
      },
    ],
  };
};
